import React from "react";
import PropTypes from "prop-types";
import { getHeaderContents } from "@sia/shared/js/contents/layout";
import { Header } from "@sia/style-guide";
import { cacheAdapter } from "contexts/Cache";
import KeycloakIDPAdapter from "common/Adapters/IDPAdapter/KeycloakIDPAdapter";

const HeaderClient = ({
  pathFactory,
  history,
  user,
  menuItems,
  i18n,
  createLanguageKeyReplacedUrl,
  translate,
  headerUser,
  defaultAppSwitcherValue,
}) => {
  const webPlatformUrl = process.env.REACT_APP_WEBSITE_URL;
  const switcherItems = React.useMemo(() => {
    const prefix = `${webPlatformUrl}/${i18n.language}`;
    const headerContentsConfig = {
      links: {
        account: {
          target: `${prefix}/account`,
          internal: false,
        },
        referenceGallery: {
          target: `${prefix}/reference-gallery`,
          internal: false,
        },
        jobs: { target: `${prefix}/jobs`, internal: false },
        directory: {
          target: `${prefix}/directory`,
          internal: false,
        },
        agenda: {
          target: `${prefix}/agenda`,
          internal: false,
        },
        valueApp: {
          target: `${prefix}/value-app`,
          internal: false,
        },
        catalog: {
          target: `${prefix}/catalog`,
          internal: false,
        },
        wizard: {
          target: `${prefix}/wizard`,
          internal: false,
        },
        cloud: {
          target: process.env.REACT_APP_CLOUD_IDP_LINK,
        },
        benchmarking: {
          target: pathFactory.create(""),
          onClick: (e) => {
            e.preventDefault();
            history.push(pathFactory.create(""));
          },
        },
      },
    };

    let items = { ...getHeaderContents(headerContentsConfig) };
    if (user?.isMemberTypeGroupOf("corporate")) {
      items = {
        ...items,
        appSwitcherLinks: items.appSwitcherLinks.filter((e) => e.name !== "cloud"),
      };
    }
    return items;
  }, [user, i18n.language]);

  const logoTarget = `${webPlatformUrl}/${i18n.language}`;
  return (
    <Header
      menuItems={menuItems}
      sharedContents={switcherItems}
      selectedLanguageKey={i18n.language}
      logoLinking={logoTarget}
      onChangeLanguage={(languageKey) => {
        cacheAdapter().clearCache();
        sessionStorage.setItem("sia.benchmarking.languageKey", languageKey);
        const languageKeyReplacedUrl = createLanguageKeyReplacedUrl(languageKey);
        window.location.replace(languageKeyReplacedUrl);
      }}
      onClickLogin={() => {
        sessionStorage.clear();
        window.location.href = KeycloakIDPAdapter.createLoginUrl(i18n.language, null, true);
      }}
      onClickLogout={() => KeycloakIDPAdapter.logout(null, true)}
      translate={translate}
      user={headerUser}
      defaultAppSwitcherValue={defaultAppSwitcherValue || false}
      // @ts-ignore
      history={history}
      reducedHeightHeader
    />
  );
};
HeaderClient.propTypes = {
  pathFactory: PropTypes.object,
  history: PropTypes.object,
  user: PropTypes.object,
  menuItems: PropTypes.array,
  i18n: PropTypes.object,
  createLanguageKeyReplacedUrl: PropTypes.func,
  translate: PropTypes.func,
  headerUser: PropTypes.object,
  defaultAppSwitcherValue: PropTypes.string,
};

export default HeaderClient;
